import { AgentStats } from '../../../components/AgentProfile/AgentStats'
import type { Agent } from '../../../services/agentService'
import { Avatar } from '../../../components/ui/Avatar'

interface ChatWelcomeScreenProps {
    agent: Agent
}

export function ChatWelcomeScreen({ agent }: ChatWelcomeScreenProps) {
    return (
        <div className="flex-1 flex flex-col items-center justify-center p-8 text-center animate-in fade-in duration-500">

            {/* Avatar with Overlay Pill - Matches Sidebar Profile Style */}
            <div className="relative mb-3 group">
                <div className="w-[133px] h-[133px] rounded-full p-[4px] bg-gradient-to-br from-blue-400 via-purple-500 to-pink-400 mx-auto transition-transform duration-500 hover:scale-105">
                    <div className="w-full h-full rounded-full overflow-hidden bg-white dark:bg-black">
                        <Avatar
                            size="xl"
                            className="w-full h-full"
                            alt={agent.name}
                            src={agent.avatar_url || undefined}
                        />
                    </div>
                </div>

                {/* Name & Badge Overlay Pill */}
                <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 flex items-center gap-1.5 bg-white dark:bg-black px-4 py-1.5 rounded-full shadow-md border border-gray-100 dark:border-gray-800 whitespace-nowrap z-10 transition-transform duration-300 hover:scale-105">
                    <h1 className="text-lg font-bold text-gray-900 dark:text-white leading-none">
                        {agent.name}
                    </h1>
                    {/* Verified Badge */}
                    <svg className="w-5 h-5 text-[#1d9bf0] flex-shrink-0" viewBox="0 0 22 22" aria-label="Verified account" role="img">
                        <g>
                            <path fill="currentColor" d="M20.396 11c-.018-.646-.215-1.275-.57-1.816-.354-.54-.852-.972-1.438-1.246.223-.607.27-1.264.14-1.897-.131-.634-.437-1.218-.882-1.687-.47-.445-1.053-.75-1.687-.882-.633-.13-1.29-.083-1.897.14-.273-.587-.704-1.086-1.245-1.44S11.647 1.62 11 1.604c-.646.017-1.273.213-1.813.568s-.969.854-1.24 1.44c-.608-.223-1.267-.272-1.902-.14-.635.13-1.22.436-1.69.882-.445.47-.749 1.055-.878 1.688-.13.633-.08 1.29.144 1.896-.587.274-1.087.705-1.443 1.245-.356.54-.555 1.17-.574 1.817.02.647.218 1.276.574 1.817.356.54.856.972 1.443 1.245-.224.606-.274 1.263-.144 1.896.13.634.433 1.218.877 1.688.47.443 1.054.747 1.687.878.633.132 1.29.084 1.897-.136.274.586.705 1.084 1.246 1.439.54.354 1.17.551 1.816.569.647-.016 1.276-.213 1.817-.567s.972-.854 1.245-1.44c.604.239 1.266.296 1.903.164.636-.132 1.22-.447 1.68-.907.46-.46.776-1.044.908-1.681s.075-1.299-.165-1.903c.586-.274 1.084-.705 1.439-1.246.354-.54.551-1.17.569-1.816zM9.662 14.85l-3.429-3.428 1.293-1.302 2.072 2.072 4.4-4.794 1.347 1.246z"></path>
                        </g>
                    </svg>
                </div>
            </div>

            {/* Handle - Visual adjustment */}
            <p className="text-[15px] text-gray-500 dark:text-gray-400 mb-4 font-medium tracking-wide">
                @{agent.handle}
            </p>

            {/* Stats - Centered - Matches layout */}
            <div className="flex justify-center mb-6">
                <AgentStats agentId={agent.id} className="justify-center" />
            </div>

            {/* Description - Matches text size [15px] */}
            {agent.description && (
                <div className="max-w-md mx-auto">
                    <p className="text-[15px] text-gray-900 dark:text-white leading-normal">
                        {agent.description}
                    </p>
                </div>
            )}
        </div>
    )
}
